














import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { SurveyError } from "survey-core";

@Component
export class QuestionError extends Vue {
  @Prop() errorKey: string;
  @Prop() error: SurveyError;
  @Prop() cssClasses: any;
  @Prop() element: any;
  constructor() {
    super();
  }
}

Vue.component("sv-question-error", QuestionError);

export default QuestionError;
